import { Box, Flex, Text } from "@chakra-ui/react";

import { GradeTheme, Logo } from "@euka-mfes/bark";
import PrimaryFooterLine from "@assets/primary-footer-line.svg";
import SecondaryFooterLine from "@assets/secondary-footer-line.svg";
import SeniorFooterLine from "@assets/senior-footer-line.svg";
import { useAppConfigSelector } from "@context/hooks";
import { getConfig } from "@edx/frontend-platform";

const getFooterStyles = (): Record<
  GradeTheme,
  {
    backgroundImage: string;
  }
> => ({
  PRIMARY: {
    backgroundImage: PrimaryFooterLine
  },
  SECONDARY: {
    backgroundImage: SecondaryFooterLine
  },
  SENIOR: {
    backgroundImage: SeniorFooterLine
  }
});

const Footer = () => {
  const { gradeTheme } = useAppConfigSelector();
  const footerStyles = getFooterStyles();
  const { backgroundImage } = footerStyles[gradeTheme];
  const config = getConfig();

  return (
    <Flex
      className="app-footer"
      justify="center"
      alignContent="center"
      w="100%"
      minW="100%"
      direction="column"
      mb={8}
    >
      <Box
        w="100%"
        h="10px"
        position="relative"
        overflow="hidden"
        aria-hidden
        backgroundRepeat="no-repeat"
        backgroundImage={`url("${backgroundImage}")`}
        data-testid="footer-line"
      />
      <Flex 
        justifyContent="flex-start"
        pt={4} 
        gap={6}
        css={{
          "@media screen and (min-width: 1024px)": {
            justifyContent: "space-between",
            gap: 0
          }
        }}
      >
        <Flex alignItems="center" justifyContent="flex-start">
          <Logo variant="inline" size="lg" hasBreakpointSizes={false} />
        </Flex>
        <Flex 
          gap={0.5} 
          justifyContent="flex-start"
          flexDirection="column"
          css={{
            "@media screen and (min-width: 1024px)": {
              justifyContent: "flex-end"
            }
          }}
        >
          <Text textStyle="folio.standard">© Euka Future Learning Pty Ltd</Text>
          <Text
            textStyle="folio.standard"
            textAlign="left"
            color="slateGray.600"
            css={{
              "@media screen and (min-width: 1024px)": {
                textAlign: "right"
              }
            }}
          >
            V{config.UI_VERSION}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Footer;
